import React, {useEffect, useState} from 'react';
import { DividedCardContainer, DividedContainerRow, H1, H2, ProductCard, ProductImage, ProductInfo, ProductName, ProductsContainer, UserContainer } from './style';
import { DividedContainer } from './style';
import Card from '../../../Components/Miscellaneous/Card';
import { useParams } from 'react-router-dom';
import AuthService from '../../../AuthService';
import { ProductCardImage, ProductCardTitle } from '../../Categories/style';
import Button from '../../../Components/Miscellaneous/Button';
import { TiTick } from "react-icons/ti";
import { RxCross2 } from "react-icons/rx";
import { MdPayment, MdLocationOn, MdEmail, MdPhone, MdPerson, MdDateRange, MdShoppingCart, MdLocalShipping, MdStore, MdVerified, MdStar } from "react-icons/md";
import { FileUploader } from "react-drag-drop-files";
import { toast } from 'react-toastify';

export default function Order() {

    const [order, setOrder] = useState([]);

    const {id} = useParams();
    const getOrder = async () => {
        fetch(`https://api.rb.beeapp.es/admin/orders/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${AuthService.getToken()}`,
            },
        })
            .then(response => response.json())
            .then(data => {
                setOrder(data);
            });
    }
    useEffect(() => {

        getOrder();

    }
    , [id]);
    const handleChange = (file) => {
        const formData = new FormData();
        formData.append('invoice', file);
        formData.append('id', id);
        fetch(`https://api.rb.beeapp.es/admin/invoice`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${AuthService.getToken()}`,
            },
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                toast.success('Factura subida correctamente');
            }
            );
    };
    const updateStatus = async (status) => {
        fetch(`https://api.rb.beeapp.es/admin/orders/${id}/status`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${AuthService.getToken()}`,
            },
            body: JSON.stringify({
                Status: status,
            }),
        })
            .then(response => response.json())
            .then(data => {
                window.location.reload();
            }
            );
    }

    const markAsPaid = async () => {
        try {
            const response = await fetch(`https://api.rb.beeapp.es/admin/orders/${id}/payment`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${AuthService.getToken()}`,
                },
                body: JSON.stringify({
                    isPay: true,
                }),
            });

            if (response.ok) {
                const data = await response.json();
                toast.success('Pedido marcado como pagado correctamente');
                // Actualizar el estado local del pedido
                setOrder(prevOrder => ({
                    ...prevOrder,
                    isPay: true
                }));
            } else {
                const errorData = await response.json();
                toast.error(`Error: ${errorData.message}`);
            }
        } catch (error) {
            console.error('Error marking order as paid:', error);
            toast.error('Error al marcar el pedido como pagado');
        }
    }

    const status = {
        'CREATED': 'Creado',
        'PREPARING': 'Preparando',
        'SHIPPED': 'Enviado',
        'DELIVERED': 'Entregado',
        'CANCELLED': 'Cancelado',
    }

    const getStatusColor = (status) => {
        switch(status?.toUpperCase()) {
            case 'CREATED': return { bg: '#fff3cd', color: '#856404', border: '#ffeaa7' };
            case 'PREPARING': return { bg: '#d1ecf1', color: '#0c5460', border: '#b3d4fc' };
            case 'SHIPPED': return { bg: '#d4edda', color: '#155724', border: '#c3e6cb' };
            case 'DELIVERED': return { bg: '#d1e7dd', color: '#0a3622', border: '#badbcc' };
            case 'CANCELLED': return { bg: '#f8d7da', color: '#721c24', border: '#f1aeb5' };
            default: return { bg: '#e2e3e5', color: '#383d41', border: '#d6d8db' };
        }
    }

    const isBarOffice = order?.sourceApp === 'BarOffice';
    
    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: '#f8fafc',
            fontFamily: '"Inter", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
        }}>
            {/* Professional Header */}
            <div style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '2rem 0',
                marginBottom: '2rem',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}>
        <UserContainer>
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'flex-start',
                        flexWrap: 'wrap',
                        gap: '1.5rem'
                    }}>
                        <div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                marginBottom: '12px'
                            }}>
                                <MdStore style={{ color: 'white', fontSize: '2rem' }} />
                                <h1 style={{
                                    color: 'white',
                                    fontSize: '2.5rem',
                                    fontWeight: '700',
                                    margin: 0,
                                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                                }}>
                                    Pedido #{id?.slice(-8)}
                                </h1>
                            </div>
                            
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
                                <div style={{
                                    ...getStatusColor(order?.Status),
                                    backgroundColor: getStatusColor(order?.Status).bg,
                                    color: getStatusColor(order?.Status).color,
                                    border: `1px solid ${getStatusColor(order?.Status).border}`,
                                    padding: '8px 16px',
                                    borderRadius: '25px',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px'
                                }}>
                                    <MdVerified size={16} />
                                    {status[order?.Status?.toUpperCase()]}
                                </div>
                                
            {isBarOffice && (
                                    <div style={{
                                        background: 'rgba(59, 130, 246, 0.15)',
                                        border: '1px solid rgba(59, 130, 246, 0.3)',
                                        borderRadius: '25px',
                                        padding: '8px 16px',
                                        color: '#1e40af',
                                        fontWeight: '600',
                                        fontSize: '14px',
                                        backdropFilter: 'blur(10px)'
                                    }}>
                                        <MdStar style={{ marginRight: '6px', verticalAlign: 'middle' }} />
                                        Premium BarOffice
                                    </div>
                                )}
                                
                                {order?.directShipping && (
                                    <div style={{
                                        background: 'rgba(34, 197, 94, 0.15)',
                                        border: '1px solid rgba(34, 197, 94, 0.3)',
                                        borderRadius: '25px',
                                        padding: '8px 16px',
                                        color: '#059669',
                                        fontWeight: '600',
                                        fontSize: '14px',
                                        backdropFilter: 'blur(10px)'
                                    }}>
                                        <MdLocalShipping style={{ marginRight: '6px', verticalAlign: 'middle' }} />
                                        Envío Express
                                    </div>
                                )}
                            </div>
                        </div>
                        
                        <div style={{
                            background: 'rgba(255, 255, 255, 0.1)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '15px',
                            padding: '1rem 1.5rem',
                            border: '1px solid rgba(255, 255, 255, 0.2)'
                        }}>
                            <div style={{ 
                                color: 'rgba(255, 255, 255, 0.8)',
                                fontSize: '14px',
                                marginBottom: '4px'
                            }}>
                                Fecha del pedido
                            </div>
                            <div style={{
                                color: 'white',
                                fontSize: '16px',
                                fontWeight: '600'
                            }}>
                                {order?.CreationDate && new Date(order.CreationDate).toLocaleDateString('es-ES', {
                                    year: 'numeric',
                                    month: 'long', 
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                })}
                            </div>
                        </div>
                    </div>
                </UserContainer>
            </div>

            <UserContainer>
                {/* Professional Summary Cards */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                    gap: '1.5rem',
                    marginBottom: '3rem'
                }}>
                    <div style={{
                        background: 'white',
                        borderRadius: '20px',
                        padding: '2rem',
                        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                        border: '1px solid #e5e7eb',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '4px',
                            background: 'linear-gradient(90deg, #3b82f6, #8b5cf6)'
                        }} />
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ 
                                fontSize: '14px', 
                                color: '#6b7280',
                                fontWeight: '500',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                marginBottom: '8px'
                            }}>
                                Subtotal
                            </div>
                            <div style={{ 
                                fontSize: '2.5rem', 
                                fontWeight: '800', 
                                color: '#1f2937',
                                lineHeight: '1'
                            }}>
                                {order?.TotalAmount?.toFixed(2).replace('.', ',')} €
                            </div>
                        </div>
                    </div>

                    <div style={{
                        background: 'white',
                        borderRadius: '20px',
                        padding: '2rem',
                        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                        border: '1px solid #e5e7eb',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '4px',
                            background: 'linear-gradient(90deg, #f59e0b, #f97316)'
                        }} />
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ 
                                fontSize: '14px', 
                                color: '#6b7280',
                                fontWeight: '500',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                marginBottom: '8px'
                            }}>
                                Gastos de envío
                            </div>
                            <div style={{ 
                                fontSize: '2.5rem', 
                                fontWeight: '800', 
                                color: '#1f2937',
                                lineHeight: '1'
                            }}>
                                {order?.ShippingCosts} €
                            </div>
                        </div>
                    </div>

                    <div style={{
                        background: 'white',
                        borderRadius: '20px',
                        padding: '2rem',
                        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                        border: '1px solid #e5e7eb',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '4px',
                            background: 'linear-gradient(90deg, #10b981, #059669)'
                        }} />
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ 
                                fontSize: '14px', 
                                color: '#6b7280',
                                fontWeight: '500',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                marginBottom: '8px'
                            }}>
                                Total con IVA
                            </div>
                            <div style={{ 
                                fontSize: '2.5rem', 
                                fontWeight: '800', 
                                color: '#1f2937',
                                lineHeight: '1'
                            }}>
                                {((order?.TotalAmount + order?.ShippingCosts) * 1.21)?.toFixed(2)} €
                            </div>
                        </div>
                    </div>

                    <div style={{
                        background: 'white',
                        borderRadius: '20px',
                        padding: '2rem',
                        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                        border: '1px solid #e5e7eb',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '4px',
                            background: order?.isPay ? 
                                'linear-gradient(90deg, #10b981, #059669)' : 
                                'linear-gradient(90deg, #ef4444, #dc2626)'
                        }} />
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ 
                                fontSize: '14px', 
                                color: '#6b7280',
                                fontWeight: '500',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                marginBottom: '8px'
                            }}>
                                Estado de pago
                            </div>
                            <div style={{ 
                                fontSize: '1.5rem', 
                                fontWeight: '800', 
                                color: order?.isPay ? '#059669' : '#dc2626',
                                lineHeight: '1',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px'
                            }}>
                                {order?.isPay ? <MdVerified size={24} /> : <RxCross2 size={24} />}
                                {order?.isPay ? 'Pagado' : 'Pendiente'}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main Professional Content */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 1fr)',
                    gap: '2rem',
                    marginBottom: '3rem'
                }}>
                    {/* Left Column */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                        {/* Customer Information */}
                        <div style={{
                            background: 'white',
                            borderRadius: '20px',
                            padding: '2rem',
                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                            border: '1px solid #e5e7eb'
                        }}>
                            <h3 style={{
                                fontSize: '1.5rem',
                                fontWeight: '700',
                                color: '#1f2937',
                                marginBottom: '1.5rem',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                            }}>
                                <div style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    borderRadius: '10px',
                                    padding: '8px',
                                    color: 'white'
                                }}>
                                    <MdPerson size={20} />
                                </div>
                                Información del Cliente
                            </h3>
                            
                            <div style={{ display: 'grid', gap: '1rem' }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    padding: '1rem',
                                    backgroundColor: '#f8fafc',
                                    borderRadius: '12px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <MdPerson style={{ color: '#6b7280', fontSize: '20px' }} />
                                    <div>
                                        <div style={{ fontWeight: '600', fontSize: '16px', color: '#1f2937' }}>
                                            {order?.UserID?.Name} {order?.UserID?.Surname}
                                        </div>
                                        <div style={{ fontSize: '14px', color: '#6b7280' }}>Cliente</div>
                                    </div>
                                </div>

                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    padding: '1rem',
                                    backgroundColor: '#f8fafc',
                                    borderRadius: '12px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <MdEmail style={{ color: '#6b7280', fontSize: '20px' }} />
                                    <div>
                                        <div style={{ fontWeight: '500', fontSize: '16px', color: '#1f2937' }}>
                                            {order?.UserID?.Email}
                                        </div>
                                        <div style={{ fontSize: '14px', color: '#6b7280' }}>Email</div>
                                    </div>
                                </div>

                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    padding: '1rem',
                                    backgroundColor: '#f8fafc',
                                    borderRadius: '12px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    <MdPhone style={{ color: '#6b7280', fontSize: '20px' }} />
                                    <div>
                                        <div style={{ fontWeight: '500', fontSize: '16px', color: '#1f2937' }}>
                                            {order?.UserID?.Phone}
                                        </div>
                                        <div style={{ fontSize: '14px', color: '#6b7280' }}>Teléfono</div>
                                    </div>
                                </div>

                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gap: '1rem',
                                    padding: '1.5rem',
                                    backgroundColor: '#f1f5f9',
                                    borderRadius: '12px',
                                    border: '1px solid #cbd5e1'
                                }}>
                                    <div>
                                        <div style={{ fontSize: '14px', color: '#64748b', fontWeight: '500' }}>CIF</div>
                                        <div style={{ fontSize: '16px', color: '#1e293b', fontWeight: '600' }}>
                                            {order?.UserID?.CIF}
                                        </div>
                                    </div>
                                    <div>
                                        <div style={{ fontSize: '14px', color: '#64748b', fontWeight: '500' }}>Recargo Equiv.</div>
                                        <div style={{ 
                                            fontSize: '16px',
                                            color: order?.UserID?.EquivalenceSurcharge ? '#059669' : '#dc2626',
                                            fontWeight: '600'
                                        }}>
                                            {order?.UserID?.EquivalenceSurcharge ? 'Sí' : 'No'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Shipping Address */}
                        {order?.Address?.map((address, index) => (
                            <div key={index} style={{
                                background: 'white',
                                borderRadius: '20px',
                                padding: '2rem',
                                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                                border: '1px solid #e5e7eb'
                            }}>
                                <h3 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '1.5rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}>
                                    <div style={{
                                        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                        borderRadius: '10px',
                                        padding: '8px',
                                        color: 'white'
                                    }}>
                                        <MdLocationOn size={20} />
                                    </div>
                                    Dirección de Entrega
                                </h3>
                                
                                <div style={{
                                    padding: '1.5rem',
                                    backgroundColor: '#f8fafc',
                                    borderRadius: '15px',
                                    border: '2px solid #e2e8f0',
                                    position: 'relative'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: '-1px',
                                        left: '-1px',
                                        right: '-1px',
                                        height: '4px',
                                        background: 'linear-gradient(90deg, #10b981, #059669)',
                                        borderRadius: '15px 15px 0 0'
                                    }} />
                                    <div style={{ fontWeight: '700', fontSize: '18px', color: '#1f2937', marginBottom: '8px' }}>
                                        {address.Address}
                                    </div>
                                    <div style={{ fontSize: '16px', color: '#4b5563', marginBottom: '4px' }}>
                                        {address.City}, {address.ZIP}
                                    </div>
                                    <div style={{ fontSize: '16px', color: '#6b7280' }}>
                                        {address.Country}
                                    </div>
                                </div>
                            </div>
                        ))}

                        {/* Ecommerce Data */}
                        {order?.ecommerceData && (
                            <div style={{
                                background: 'white',
                                borderRadius: '20px',
                                padding: '2rem',
                                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                                border: '1px solid #e5e7eb'
                            }}>
                                <h3 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '1.5rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}>
                                    <div style={{
                                        background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                                        borderRadius: '10px',
                                        padding: '8px',
                                        color: 'white'
                                    }}>
                                        <MdShoppingCart size={20} />
                                    </div>
                                    Detalles del Pedido
                                </h3>
                                
                                <div style={{ display: 'grid', gap: '1rem' }}>
                                    <div style={{
                                        display: 'grid',
                                        gridTemplateColumns: '1fr 1fr',
                                        gap: '1rem',
                                        padding: '1rem',
                                        backgroundColor: '#f8fafc',
                                        borderRadius: '12px',
                                        border: '1px solid #e2e8f0'
                                    }}>
                                        <div>
                                            <div style={{ fontSize: '14px', color: '#64748b', fontWeight: '500', marginBottom: '4px' }}>
                                                Método de pago
                                            </div>
                                            <div style={{ fontSize: '16px', color: '#1e293b', fontWeight: '600' }}>
                                                {order?.PaymentMethod}
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '14px', color: '#64748b', fontWeight: '500', marginBottom: '4px' }}>
                                                Tipo de pedido
                                            </div>
                                            <div style={{ fontSize: '16px', color: '#1e293b', fontWeight: '600' }}>
                                                {order?.ecommerceData?.orderType}
                                            </div>
                                        </div>
                                    </div>

                                    {order?.ecommerceData?.originalCartId && (
                                        <div style={{
                                            padding: '1rem',
                                            backgroundColor: '#eff6ff',
                                            borderRadius: '12px',
                                            border: '1px solid #bfdbfe'
                                        }}>
                                            <div style={{ fontSize: '14px', color: '#1e40af', fontWeight: '500', marginBottom: '4px' }}>
                                                ID del Carrito
                                            </div>
                                            <div style={{ fontSize: '16px', color: '#1e3a8a', fontWeight: '600', fontFamily: 'monospace' }}>
                                                {order?.ecommerceData?.originalCartId?.slice(-12)}
                                            </div>
                                        </div>
                                    )}

                                    {order?.ecommerceData?.notes && (
                                        <div style={{
                                            padding: '1.5rem',
                                            backgroundColor: '#fffbeb',
                                            borderRadius: '12px',
                                            border: '2px solid #fbbf24',
                                            position: 'relative'
                                        }}>
                                            <div style={{
                                                fontSize: '14px',
                                                color: '#92400e',
                                                fontWeight: '600',
                                                marginBottom: '8px',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px'
                                            }}>
                                                Notas del cliente
                                            </div>
                                            <div style={{ fontSize: '16px', color: '#78350f', lineHeight: '1.6' }}>
                                                {order?.ecommerceData?.notes}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        </div>

                    {/* Right Column - Actions & Billing */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                        {/* Actions */}
                        <div style={{
                            background: 'white',
                            borderRadius: '20px',
                            padding: '2rem',
                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                            border: '1px solid #e5e7eb'
                        }}>
                            <h3 style={{
                                fontSize: '1.5rem',
                                fontWeight: '700',
                                color: '#1f2937',
                                marginBottom: '1.5rem',
                                textAlign: 'center'
                            }}>
                                Panel de Control
                            </h3>
                            
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                {isBarOffice && (
                                    <button 
                                        style={{
                                            background: 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)',
                                            border: 'none',
                                            borderRadius: '15px',
                                            color: 'white',
                                            padding: '1rem 1.5rem',
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                                            transition: 'all 0.2s',
                                            fontFamily: 'inherit'
                                        }}
                                        onClick={markAsPaid}
                                        onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                                        onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                                    >
                                        <MdPayment size={20} />
                                        Marcar como Pagado
                                    </button>
                                )}
                                
                                {order?.Status?.toUpperCase() !== 'SHIPPED' && (
                                    <>
                                        <button 
                                        style={{
                                                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                                border: 'none',
                                                borderRadius: '15px',
                                                color: 'white',
                                                padding: '1rem 1.5rem',
                                                fontSize: '16px',
                                                fontWeight: '600',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '8px',
                                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                                                transition: 'all 0.2s',
                                                fontFamily: 'inherit'
                                            }}
                                            onClick={() => updateStatus('Shipped')}
                                            onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                                            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                                        >
                                            <MdLocalShipping size={20} />
                                            Marcar como Enviado
                                        </button>
                                        
                                        <button 
                        style={{
                                                background: 'white',
                                                border: '2px solid #3b82f6',
                                                borderRadius: '15px',
                                                color: '#3b82f6',
                                                padding: '1rem 1.5rem',
                                                fontSize: '16px',
                                                fontWeight: '600',
                                                cursor: 'pointer',
                            display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '8px',
                                                transition: 'all 0.2s',
                                                fontFamily: 'inherit'
                                            }}
                                            onClick={() => updateStatus('Preparing')}
                                            onMouseOver={(e) => {
                                                e.target.style.backgroundColor = '#3b82f6';
                                                e.target.style.color = 'white';
                                            }}
                                            onMouseOut={(e) => {
                                                e.target.style.backgroundColor = 'white';
                                                e.target.style.color = '#3b82f6';
                                            }}
                                        >
                                            Preparar Pedido
                                        </button>
                                    </>
                                )}
                                
                                <button 
                                    style={{
                                        background: 'white',
                                        border: '2px solid #ef4444',
                                        borderRadius: '15px',
                                        color: '#ef4444',
                                        padding: '1rem 1.5rem',
                                        fontSize: '16px',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        transition: 'all 0.2s',
                                        fontFamily: 'inherit'
                                    }}
                                    onClick={() => updateStatus('Cancelled')}
                                    onMouseOver={(e) => {
                                        e.target.style.backgroundColor = '#ef4444';
                                        e.target.style.color = 'white';
                                    }}
                                    onMouseOut={(e) => {
                                        e.target.style.backgroundColor = 'white';
                                        e.target.style.color = '#ef4444';
                                    }}
                                >
                                    Cancelar Pedido
                                </button>
                            </div>
                    </div>

                        {/* Billing */}
                        <div style={{
                            background: 'white',
                            borderRadius: '20px',
                            padding: '2rem',
                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                            border: '1px solid #e5e7eb'
                        }}>
                            <h3 style={{
                                fontSize: '1.5rem',
                                fontWeight: '700',
                                color: '#1f2937',
                                marginBottom: '1.5rem',
                                textAlign: 'center'
                            }}>
                                Facturación
                            </h3>
                            
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                {order?.Billings?.length > 0 && order.Billings.map((billing, index) => (
                                    <button 
                                        key={index}
                                        style={{
                                            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                            border: 'none',
                                            borderRadius: '15px',
                                            color: 'white',
                                            padding: '1rem 1.5rem',
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                                            transition: 'all 0.2s',
                                            fontFamily: 'inherit'
                                        }}
                                        onClick={() => window.open(billing.BillURL)}
                                        onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                                        onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                                    >
                                        📄 Descargar Factura #{index + 1}
                                    </button>
                                ))}
                                
                                <div style={{
                                    border: '2px dashed #cbd5e1',
                                    borderRadius: '15px',
                                    padding: '1.5rem',
                                    textAlign: 'center',
                                    backgroundColor: '#f8fafc'
                                }}>
                                    <FileUploader 
                                        handleChange={handleChange}
                                        name="invoice" 
                                        types={['PDF']} 
                                        label="📤 Subir nueva factura"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </UserContainer>

            {/* Professional Products Section */}
            <div style={{
                background: 'white',
                borderRadius: '24px',
                padding: '2.5rem',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                border: '1px solid #f1f5f9',
                marginBottom: '2rem',
                position: 'relative',
                overflow: 'hidden'
            }}>
                {/* Header with gradient background */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '6px',
                    background: 'linear-gradient(90deg, #8b5cf6, #3b82f6, #10b981, #f59e0b)',
                    backgroundSize: '400% 400%',
                    animation: 'gradient 8s ease infinite'
                }} />
                
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '2rem',
                    flexWrap: 'wrap',
                    gap: '1rem'
                }}>
                    <h2 style={{
                        fontSize: '2.25rem',
                        fontWeight: '800',
                        color: '#1f2937',
                        margin: 0,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px'
                    }}>
                        <div style={{
                            background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                            borderRadius: '16px',
                            padding: '12px',
                            color: 'white',
                            boxShadow: '0 10px 15px -3px rgba(139, 92, 246, 0.4)'
                        }}>
                            <MdShoppingCart size={28} />
                        </div>
                        Productos Incluidos
                    </h2>
                    
                    <div style={{
                        background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
                        borderRadius: '50px',
                        padding: '8px 20px',
                        color: '#374151',
                        fontWeight: '700',
                        fontSize: '16px',
                        border: '2px solid #d1d5db'
                    }}>
                        {order?.Products?.length || 0} artículos
                    </div>
                </div>
                
                {/* Simple Products List */}
                <div style={{
                    background: 'white',
                    borderRadius: '12px',
                    padding: '1.5rem',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                    border: '1px solid #e5e7eb',
                    marginBottom: '2rem'
                }}>
                    <h3 style={{
                        fontSize: '1.25rem',
                        fontWeight: '600',
                        color: '#1f2937',
                        marginBottom: '1rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <MdShoppingCart size={20} />
                        Productos ({order?.Products?.length || 0})
                    </h3>
                    
                    <div style={{ display: 'grid', gap: '12px' }}>
                        {order?.Products?.map((product, index) => (
                            <div key={index} style={{
                                display: 'grid',
                                gridTemplateColumns: '60px 1fr 120px auto',
                                gap: '12px',
                                padding: '12px',
                                backgroundColor: '#f8fafc',
                                borderRadius: '8px',
                                border: '1px solid #e2e8f0',
                                alignItems: 'center'
                            }}>
                                {/* Product Image */}
                                <div style={{
                                    borderRadius: '6px',
                                    overflow: 'hidden',
                                    background: 'white'
                                }}>
                                    <ProductImage 
                                        src={product.product.images[0]} 
                                        alt={product.product.name}
                                        style={{
                                            width: '60px',
                                            height: '60px',
                                            objectFit: 'cover'
                                        }}
                                    />
                                </div>
                                
                                {/* Product Info */}
                                <div style={{ minWidth: 0 }}>
                                    <h4 style={{
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#1f2937',
                                        marginBottom: '4px',
                                        lineHeight: '1.3'
                                    }}>
                                        {product.product.name}
                                    </h4>
                                    <div style={{
                                        fontSize: '12px',
                                        color: '#6b7280',
                                        display: 'flex',
                                        gap: '8px',
                                        flexWrap: 'wrap'
                                    }}>
                                        <span>Ref: {product.product.reference}</span>
                                        <span>•</span>
                                        <span>{product.quantity} uds</span>
                                        <span>•</span>
                                        <span>{product.price.toFixed(2).replace('.', ',')} €</span>
                                    </div>
                                </div>
                                
                                {/* Price */}
                                <div style={{
                                    textAlign: 'right'
                                }}>
                                    <div style={{
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#1f2937'
                                    }}>
                                        {(product.price * product.quantity).toFixed(2).replace('.', ',')} €
                                    </div>
                                    <div style={{
                                        fontSize: '11px',
                                        color: product.prepared ? '#059669' : '#dc2626',
                                        fontWeight: '500'
                                    }}>
                                        {product.prepared ? '✓ Listo' : '⏳ Pendiente'}
                                    </div>
                                </div>
                                
                                {/* Action Button */}
                                <button 
                                    style={{
                                        background: product.prepared ? '#10b981' : '#ef4444',
                                        border: 'none',
                                        borderRadius: '50%',
                                        color: 'white',
                                        width: '32px',
                                        height: '32px',
                                        fontSize: '16px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    {product.prepared ? <TiTick /> : <RxCross2 />}
                                </button>
                            </div>
                        ))}
                    </div>
                    
                    {/* Simple Summary */}
                    {order?.Products?.length > 0 && (
                        <div style={{
                            marginTop: '1rem',
                            padding: '12px',
                            backgroundColor: '#f1f5f9',
                            borderRadius: '6px',
                            fontSize: '12px',
                            color: '#6b7280',
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <span>Total: {order.Products.length} productos</span>
                            <span>Preparados: {order.Products.filter(p => p.prepared).length}</span>
                            <span>Pendientes: {order.Products.filter(p => !p.prepared).length}</span>
                        </div>
                    )}
                </div>
            </div>

            {/* Order Notes */}
            {order?.OrderNotes?.length > 0 && (
                <div style={{ marginTop: '32px' }}>
                    <H2 isBarOffice={isBarOffice} style={{ marginBottom: '16px' }}>Notas del Pedido</H2>
                    <Card>
                        {order.OrderNotes.map((note, index) => (
                            <div key={index} style={{ 
                                padding: '12px',
                                backgroundColor: '#f8fafc',
                                borderRadius: '6px',
                                marginBottom: '8px',
                                borderLeft: '4px solid ' + (isBarOffice ? '#1e40af' : '#028322')
                            }}>
                                {note}
                            </div>
                        ))}
                    </Card>
                </div>
            )}
        </div>
    )
}
